var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9366 19.7932C18.7428 19.9307 18.5088 20 18.2712 20H0.999999C0.447714 20 0 19.5523 0 19C0 18.4477 0.447715 18 1 18H18.246C19.2888 18 19.787 19.1898 18.9366 19.7932ZM24 10C24 10.5658 23.5236 11 22.9578 11H1C0.447715 11 0 10.5523 0 10C0 9.44771 0.447715 9 1 9H22.9578C23.5236 9 24 9.43425 24 9.99998V10ZM18.9366 0.206798C19.787 0.810239 19.2888 2 18.246 2H0.999999C0.447714 2 0 1.55228 0 1C0 0.447715 0.447715 0 1 0H18.2712C18.5088 0 18.7428 0.0692779 18.9366 0.206798Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.78055b67747899f5f62e1e42e46ca630.svg";
export { ForwardRef as ReactComponent };